import React, { useState } from "react";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  name: string;
  id: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  value?: any;
  copy?: boolean;
  errors?: any;
  touched?: any;
  onChange?: any;
  onBlur?: any;
}

const CustomInputPassword = ({
  name,
  id,
  label,
  placeholder,
  disabled,
  copy,
  value,
  errors,
  touched,
  onChange,
  onBlur,
  ...props
}: Props) => {
  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // Handle password field visiblity
  const [visible, setVisible] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const copyToClipboard = () => {
    window.prompt("Copy to clipboard: Ctrl+C, Enter", value);
  };

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className={`password-field ${touched && errors ? "is-invalid" : ""}`}>
      <label htmlFor={name}>{label}</label>

      <input
        type={visible ? "text" : "password"}
        name={name}
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        className={`form-control ${touched && errors ? "is-invalid" : ""}`}
        onChange={onChange}
        onBlur={onBlur}
        defaultValue={value}
      />
      {!!errors && touched && <div className="invalid-feedback">{errors}</div>}

      {!!copy && (
        <i
          className="fas fa-copy"
          onClick={() => {
            copyToClipboard();
          }}
        ></i>
      )}

      {!!value && (
        <i
          className={`fas ${visible ? "fa-eye-slash" : "fa-eye"}`}
          onClick={() => {
            setVisible(!visible);
          }}
        ></i>
      )}
    </div>
  );
};
export default CustomInputPassword;
